import { UseMutationOptions } from '@tanstack/react-query';

import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import { SystemTemplates } from 'models/automation/SystemTemplates';
import API from 'services/API';

type UseEnableSystemTemplateMutationArgs = {
  key: SystemTemplates;
};

type ReactQueryMutationOptions<TContext = unknown> = Omit<
  UseMutationOptions<
    {},
    BaseErrorResponse,
    UseEnableSystemTemplateMutationArgs,
    TContext
  >,
  'mutationFn' | 'mutationKey'
>;

const enableSystemTemplate = ({
  key,
  ...payload
}: UseEnableSystemTemplateMutationArgs) => {
  return API.post<{}, BaseErrorResponse>(
    `/api/internal/automation/system-templates/${key}/enable`,
    payload,
  );
};

const useEnableSystemTemplateMutation = <TContext>({
  ...options
}: ReactQueryMutationOptions<TContext> = {}) => {
  return useAppMutation({
    mutationFn: enableSystemTemplate,
    ...options,
  });
};

export default useEnableSystemTemplateMutation;
